<template>
  <div v-if="error.length" class="error">
    Please correct the following errors:
    <ul>
      <li v-for="(err, index) in error" :key="index">{{ err }}</li>
    </ul>
  </div>

  <div class="cell small-12">
    <h1>Pension Fund Name</h1>
    <p>When the pension is deduction from your employee, a deduction will appear on their payslip, please provide the name that you wish to be displayed.</p>
    </div>
    <div class="cell small-6">
        <form class="fieldset" @submit.prevent>
          <label class="strong" for="name">Pension Fund Name</label>
            <input 
              type="text" 
              id="pensionFundName" 
              name="pensionFundName" 
              placeholder="" 
              v-model="formData.pensionFundName" 
              required >
        </form>
      </div>



</template>


<script setup>

import { ref, onMounted } from 'vue'

const error = ref([]);

const props = defineProps({
  formData: Object
})


const validateStep = () => {

  error.value = [];

  if (!props.formData.pensionFundName || !props.formData.pensionFundName.trim()) {
    error.value.push('Pension Fund Name is required.');
  }

  if (error.value.length > 0) return false;


  return true;
}



const executeStep = async () => {
  return true;
}



onMounted(() => {

});

defineExpose({ validateStep, executeStep });

</script>